<template>
  <div>
    <section class="d-f justify-b align-c">
      <p class="d-f align-c c-666 f-s-12 p-b-10">
        <span class="m-r-5">订单号：{{ flowInfo.orderId }}</span>
        <span class="m-r-5">
          {{ flowInfo.qcOrderType == 3 ? '质检' : '质控' }}任务号：
          <span v-if="flowInfo.qcOrderType != 3">
            {{ parseInt($route.query.taskType) === 1 ? '主质控-' : '子质控-' }}
          </span>
          {{ $route.query.qcTaskId }}
          <el-tag size="mini">
            {{
              flowInfo.qcOrderType == 1
                ? '质控'
                : flowInfo.qcOrderType == 2
                ? 'MTQC'
                : '质检'
            }}
          </el-tag>
        </span>
        <span class="m-r-5">
          任务状态：{{ $flowTaskStatus.get(flowInfo.status) }}
        </span>
        <span class="m-r-5">
          任务金额：
          <em class="c-warning f-w-600">￥{{ flowInfo.amount }}</em>
        </span>
        <el-tag
          v-show="flowInfo.engineName"
          class="m-l-6"
          key="flowInfo.engineName"
          type="success"
          effect="plain"
        >
          {{ flowInfo.engineName }}
        </el-tag>
        <el-tag
          v-show="flowInfo.expressWay"
          class="m-l-6"
          key="flowInfo.engineName"
          type="warning"
          effect="plain"
        >
          表达方式 : {{ flowInfo.expressWay === 1 ? '敬语' : '简语' }}
        </el-tag>
        <el-button
          v-if="isKit == 'false'"
          class="m-l-5"
          type="primary"
          size="mini"
          :staParams="staParams"
          @click="showWhiteList"
        >
          白名单管理
        </el-button>
        <el-button
          v-if="isKit == 'false'"
          class="m-l-5"
          type="primary"
          size="mini"
          :staParams="staParams"
          @click="showBlackList"
        >
          黑名单管理
        </el-button>
        <el-button
          class="m-l-5"
          type="primary"
          size="mini"
          v-if="flowInfo.status === 1 && isShowPreBtn"
          @click="previewNotice"
        >
          预览后领取
        </el-button>
        <el-button
          class="m-l-5"
          type="primary"
          size="mini"
          v-if="flowInfo.status === 1 && !isShowPreBtn"
          @click.stop="receiveQctask()"
        >
          领取任务
        </el-button>
        <el-button
          class="m-l-5"
          type="primary"
          size="mini"
          v-if="flowInfo.status === 2"
          @click.stop="submitQctask(parseInt($route.query.taskType))"
        >
          {{
            parseInt($route.query.taskType) === 1
              ? '质控任务整体提交'
              : '子质控任务提交'
          }}
        </el-button>
      </p>
    </section>
    <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        label="质控任务列表"
        name="2"
        v-if="isKit == 'false' && flowInfo.status == 2"
      >
        <qcTaskListProcess
          v-if="flowInfo.orderId"
          :flowStatus="flowInfo.status"
          :orderId="flowInfo.orderId"
          :orderTag="flowInfo.orderTag"
          :qcOrderType="flowInfo.qcOrderType"
          :flowTlan="flowInfo.tlan"
          :staParams="staParams"
          @flowLevel="getFlowLevel"
          @changeMainTaskStatus="changeMainTaskStatus"
          ref="process"
        />
      </el-tab-pane>
      <el-tab-pane label="原稿" name="1">
        <fileDown
          v-if="flowInfo.orderId"
          :actStatus="actStatus"
          @getPreStatus="getPreviewStatus"
          :type="1"
          :taskType="6"
          :orderId="flowInfo.orderId"
          :staParams="staParams"
          key="ori"
          ref="ori"
        />
      </el-tab-pane>
      <el-tab-pane
        :label="isKit == 'false' ? '质控终稿' : '质检终稿'"
        v-if="flowInfo.status === 3"
        name="3"
      >
        <el-row>
          <el-col offset="1">
            <el-radio-group v-model="tranFromat">
              <el-radio label="1">纯译文</el-radio>
              <el-radio label="2">段段对照</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <fileDown
          v-if="flowInfo.orderId"
          :taskType="6"
          :type="6"
          :tranFromat="tranFromat"
          :orderId="flowInfo.orderId"
          :staParams="staParams"
          key="qc"
          ref="qcDown"
        />
      </el-tab-pane>
      <el-tab-pane
        label="质控数据"
        v-if="
          isKit == 'false' &&
          parseInt($route.query.taskType) === 1 &&
          (flowInfo.status === 2 || flowInfo.status === 3)
        "
        name="4"
      >
        <zkStatistics :orderId="flowInfo.orderId" ref="zkStatistics" />
      </el-tab-pane>
      <el-tab-pane v-if="isKit == 'false'" label="项目公告" name="5">
        <projectNotice
          ref="qcProjectNotice"
          :status="flowInfo.status"
          :id="flowInfo.id"
          :taskType="flowInfo.taskType"
          :orderId="flowInfo.orderId"
        />
      </el-tab-pane>
      <el-tab-pane v-if="isKit == 'false'" label="工作职责" name="6">
        <jobDuties
          :taskType="flowInfo.taskType"
          :qcOrderType="flowInfo.qcOrderType"
          :flowStatus="flowInfo.status"
          :taskNum="flowInfo.qcTaskNum"
        ></jobDuties>
      </el-tab-pane>
    </el-tabs>

    <!-- 质控任务整体提交 -->
    <el-dialog
      title="质控任务整体提交"
      :visible.sync="dialogQcListVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div
        class="dialog-div"
        v-if="checkSubmitMainTaskCode === -3 || checkSubmitMainTaskCode === -6"
      >
        温馨提示：当前
        <span style="color: red">子质控任务未完成提交</span>
        ，请先联系子质控提交任务，或强行结束子质控任务；（注意：子质控未完成的部分，需要主质控来完成）
      </div>
      <div class="dialog-div" v-if="checkSubmitMainTaskCode === -4">
        温馨提示：当前
        <span style="color: red">
          {{
            flowLevel == 3 ? 'PE' : flowLevel == 4 ? '审核' : 'PE审核'
          }}环节尚未完结
        </span>
        ，如您确认质控任务已完成，请联系PM结束{{
          flowLevel == 3 ? 'PE' : flowLevel == 4 ? '审核' : 'PE审核'
        }}任务后，再提交质控任务
      </div>
      <div
        class="card_ul"
        v-if="checkSubmitMainTaskCode === -3 || checkSubmitMainTaskCode === -6"
      >
        <div
          v-for="(item, index) in qcListData"
          :key="index"
          class="d-f justify-s align-c p-10"
        >
          <span class="p-10">
            子{{
              item.qcTaskId.substr(
                item.qcTaskId.length - 6,
                item.qcTaskId.length,
              ) + ' '
            }}
            <span v-if="item.qcId">{{ item.qcId }}</span>
            <span v-else>
              <span v-if="item.status == -1"></span>
              <span v-if="item.status == 1">待领取</span>
              <span v-if="item.status == 2">进行中</span>
              <span v-if="item.status == 3">已提交</span>
            </span>
          </span>
          <span v-if="item.status === 3" style="line-height: 38px">已提交</span>
          <span v-if="item.status === -1" style="line-height: 38px">
            已取消
          </span>
          <el-button
            v-if="item.status === 2"
            type="primary"
            @click="submitSubQcTask(item, index)"
          >
            强行结束
          </el-button>
          <span v-if="item.smartCheckStatus === 2">（智能检查中）</span>
          <el-button
            v-if="item.status === 1"
            type="primary"
            @click="cancelQcTask(item, index)"
          >
            取消
          </el-button>
          <el-tag size="large" class="m-5">
            <span class="m-r-10" v-if="flowLevel == 3 || flowLevel == 5">
              未完成PE翻译任务：{{ item.peNum || 0 }}
            </span>
            <span class="m-r-10" v-if="flowLevel == 4 || flowLevel == 5">
              未完成PE审核任务：{{ item.peAuditNum || 0 }}
            </span>
            <span>待处理句数：{{ item.underReviewNum || 0 }}</span>
          </el-tag>
        </div>
      </div>
      <span slot="footer" class="dialog-footer d-f justify-c">
        <el-button type="primary" @click="overallDubmission">确认</el-button>
        <el-button type="info" @click="overallDubmission" plain>取消</el-button>
      </span>
    </el-dialog>

    <!-- 黑名单管理弹窗 -->
    <blackList
      v-if="blackListVisible"
      :blackListVisible="blackListVisible"
      :staParams="staParams"
      ref="blackListOption"
    />

    <!-- 白名单管理弹窗 -->
    <whiteList
      v-if="whiteListVisible"
      :whiteListVisible="whiteListVisible"
      :staParams="staParams"
      ref="whiteListOption"
    ></whiteList>

    <el-dialog
      :show-close="!firstFlag"
      :title="firstFlag ? '子质控职责提示' : '子质控领取提示'"
      :visible.sync="isShowChildQc"
    >
      <div>
        <div class="l-h-26">
          该任务{{ flowInfo.wordNum }}字词
          <span class="c-danger" v-if="flowInfo.isMtOut">
            （机翻直出{{ flowInfo.mtoutWordNum || 0 }}字词）
          </span>
        </div>
        <div class="l-h-26">
          任务结束时间
          <span>{{ formatDate(flowInfo.limitTime) }}</span>
        </div>
        <p class="c-333 f-w-600 m-b-5">
          您领取到了一个
          <span class="c-red">子质控</span>
          任务，您需要完成以下职责：
        </p>
        <div class="l-h-26">1、处理并完成此任务的稿件质控工作；</div>
        <div class="l-h-26">2、输出的译稿千字综合差错率不得高于1.5‰；</div>
        <div class="l-h-26">3、遵守项目经理给出的具体项目要求；</div>
        <div class="l-h-26">4、确保任务整体提交时，无未处理的句子数；</div>
        <div class="l-h-26">5、项目若有延期风险，提前联系PM沟通预警；</div>
      </div>
      <div slot="footer">
        <el-button v-if="firstFlag" type="primary" @click="closeNotice">
          知道了
        </el-button>
        <section v-else>
          <el-button type="primary" @click="reciveQc">确定</el-button>
          <el-button type="primary" plain @click="isShowChildQc = false">
            取消
          </el-button>
        </section>
      </div>
    </el-dialog>
    <el-dialog
      :show-close="!firstFlag"
      :title="firstFlag ? '子MTQC订单职责提示' : '子MTQC订单领取提示'"
      :visible.sync="isShowChildMTQC"
    >
      <div>
        <div class="l-h-26">
          该任务{{ flowInfo.wordNum }}字词
          <span class="c-danger" v-if="flowInfo.isMtOut">
            （机翻直出{{ flowInfo.mtoutWordNum || 0 }}字词）
          </span>
        </div>
        <div class="l-h-26">
          任务结束时间
          <span>{{ formatDate(flowInfo.limitTime) }}</span>
        </div>
        <p class="c-333 f-w-600 m-b-5">
          您领取到了一个
          <span class="c-red">子MTQC</span>
          任务，您需要完成以下职责：
        </p>
        <div class="l-h-26">1、处理并完成此任务的稿件全文MTPE工作；</div>
        <div class="l-h-26">2、输出的译稿千字综合差错率不得高于1.5‰；</div>
        <div class="l-h-26">3、遵守项目经理给出的具体项目要求；</div>
        <div class="l-h-26">4、确保任务整体提交时，无未处理的句子数；</div>
        <div class="l-h-26">5、项目若有延期风险，提前联系PM沟通预警；</div>
      </div>
      <div slot="footer">
        <el-button v-if="firstFlag" type="primary" @click="closeNotice">
          知道了
        </el-button>
        <section v-else>
          <el-button type="primary" @click="reciveQc">确定</el-button>
          <el-button type="primary" plain @click="isShowChildMTQC = false">
            取消
          </el-button>
        </section>
      </div>
    </el-dialog>
    <el-dialog
      :show-close="!firstFlag"
      :title="firstFlag ? '主质控职责提示' : '主质控领取提示'"
      :visible.sync="isShowMainQc"
    >
      <div>
        <div class="l-h-26">
          该任务{{ flowInfo.wordNum }}字词
          <span class="c-danger" v-if="flowInfo.isMtOut">
            （机翻直出{{ flowInfo.mtoutWordNum || 0 }}字词）&nbsp;&nbsp;
            <span v-if="flowInfo.qcTaskNum > 1">
              任务金额：{{
                flowInfo.amount
              }}元（本费用含子控任务检查以及整个项目统稿费用）
            </span>
          </span>
        </div>
        <div class="l-h-26">
          任务结束时间
          <span>{{ formatDate(flowInfo.limitTime) }}</span>
        </div>
        <p class="c-333 f-w-600">
          您领取到了一个
          <span class="c-red">主质控</span>
          任务，您需要完成以下职责：
        </p>
        <div class="l-h-26">1、处理并完成此任务的稿件全文质控工作；</div>
        <div class="l-h-26">2、确保频次大于等于3次的术语准确；</div>
        <div class="l-h-26">
          3、终稿无一眼可见错误（一眼可见错误是指：封面、页眉页脚、目录、标题、表头等核心位置的错译、漏译、不统一，漏段，漏页及其他的严重不可接受低级失误。）
        </div>
        <div class="l-h-26">4、输出的译稿千字综合差错率不得高于1.5‰；</div>
        <div class="l-h-26">5、遵守项目经理给出的具体项目要求；</div>
        <div class="l-h-26">6、处理子质控未完成的句子；</div>
        <div class="l-h-26">7、确保任务整体提交时，无未处理的句子数；</div>
        <div class="l-h-26">8、项目若有延期风险，提前联系PM沟通预警；</div>
      </div>
      <div slot="footer">
        <el-button v-if="firstFlag" type="primary" @click="closeNotice">
          知道了
        </el-button>
        <section v-else>
          <el-button type="primary" @click="reciveQc">确定</el-button>
          <el-button type="primary" plain @click="isShowMainQc = false">
            取消
          </el-button>
        </section>
      </div>
    </el-dialog>
    <el-dialog
      :show-close="!firstFlag"
      :title="firstFlag ? '主MTQC订单职责提示' : '主MTQC订单领取提示'"
      :visible.sync="isShowMainMTQC"
    >
      <div>
        <div class="l-h-26">
          该任务{{ flowInfo.wordNum }}字词
          <span class="c-danger" v-if="flowInfo.isMtOut">
            （机翻直出{{ flowInfo.mtoutWordNum || 0 }}字词）&nbsp;&nbsp;
            <span v-if="flowInfo.qcTaskNum > 1">
              任务金额：{{
                flowInfo.amount
              }}元（本费用含子控任务检查以及整个项目统稿费用）
            </span>
          </span>
        </div>
        <div class="l-h-26">
          任务结束时间
          <span>{{ formatDate(flowInfo.limitTime) }}</span>
        </div>
        <p class="c-333 f-w-600">
          您领取到了一个
          <span class="c-red">主MTQC</span>
          任务，您需要完成以下职责：
        </p>
        <div class="l-h-26">1、处理并完成此任务的稿件全文MTPE工作；</div>
        <div class="l-h-26">2、确保频次大于等于3次的术语准确；</div>
        <div class="l-h-26">
          3、终稿无一眼可见错误（一眼可见错误是指：封面、页眉页脚、目录、标题、表头等核心位置的错译、漏译、不统一，漏段，漏页及其他的严重不可接受低级失误。）
        </div>
        <div class="l-h-26">4、输出的译稿千字综合差错率不得高于1.5‰；</div>
        <div class="l-h-26">5、遵守项目经理给出的具体项目要求；</div>
        <div class="l-h-26">6、处理子MTQC未完成的句子；</div>
        <div class="l-h-26">7、确保任务整体提交时，无未处理的句子数；</div>
        <div class="l-h-26">8、项目若有延期风险，提前联系PM沟通预警；</div>
      </div>
      <div slot="footer">
        <el-button v-if="firstFlag" type="primary" @click="closeNotice">
          知道了
        </el-button>
        <section v-else>
          <el-button type="primary" @click="reciveQc">确定</el-button>
          <el-button type="primary" plain @click="isShowMainMTQC = false">
            取消
          </el-button>
        </section>
      </div>
    </el-dialog>
    <el-dialog
      :show-close="!firstFlag"
      :title="firstFlag ? '质检订单职责提示' : '质检订单领取提示'"
      :visible.sync="isShowKit"
    >
      <div>
        <p class="c-333 f-w-600">
          您领取到了一个
          <span class="c-red">质检</span>
          任务，您需要完成以下职责：
        </p>
        <div class="l-h-26">1、处理并完成此任务的稿件全文质检工作；</div>
        <div class="l-h-26">2、输出的译稿千字综合差错率不得高于1.5‰；</div>
        <div class="l-h-26">3、遵守项目经理给出的具体项目要求；</div>
        <div class="l-h-26">
          4、确保任务整体提交时，审核提交全部包含错误提示的句子；
        </div>
        <div class="l-h-26">5、若出现误提示，直接提交对应句子即可；</div>
        <div class="l-h-26">6、项目若有延期风险，提前联系PM沟通预警；</div>
      </div>
      <div slot="footer">
        <el-button v-if="firstFlag" type="primary" @click="closeNotice">
          知道了
        </el-button>
        <section v-else>
          <el-button type="primary" @click="reciveQc">确定</el-button>
          <el-button type="primary" plain @click="isShowKit = false">
            取消
          </el-button>
        </section>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue';
import qcTaskListProcess from './qcTemplate/qcTaskListProcess';
import zkStatistics from '../dot/order/taskTemplate/qc-statistics';
import zkConfigure3 from '../dot/order/taskTemplate/qc-configure-status3';
import blackList from './component/blackList';
import whiteList from './component/whiteList';
import {
  checkSubmitSubTask,
  checkSubmitMainTask,
  submitMainQcTask,
  submitSubQcTask,
  cancelQcTask,
  subTaskList,
  seleteById,
  checkQcSingleOrMulti,
  incompleteSentCount,
  getUndealtWordNum,
} from '@/api/dot/qc';
import { getSpeedAndEditRemind } from '@/api/qc/qcflow';
import { receiveQc } from '@/api/qc/qcflow';
import { statistics } from '@/api/dot/flow';
import { mapGetters, mapState } from 'vuex';
import { formatDate } from '@/util/date';
import fileDown from '@/views/common/fileDown';
import projectNotice from './component/projectNotice';
import jobDuties from './component/jobDuties';

export default {
  components: {
    qcTaskListProcess,
    fileDown,
    zkStatistics,
    zkConfigure3,
    blackList,
    projectNotice,
    whiteList,
    jobDuties,
  },
  data() {
    return {
      isShowPreBtn: true,
      checkSubmitMainTaskCode: -4,
      qcListData: [],
      dialogQcListVisible: false,
      spark: 0,
      tranFromat: '1',
      activeName: '1',
      mainTaskStatus: 0,
      dialogVisible: false,
      dialogVisible2: false,
      status: 2,
      flowInfo: {},
      currentRow: {},
      isLoad: false,
      fileData: [],
      configInfo: {},
      qcName: '',
      blackListVisible: false,
      staParams: null,
      untreatedSentCount: 0,
      isShowMainQc: false,
      isShowChildQc: false,
      isShowMainMTQC: false,
      isShowChildMTQC: false,
      isShowKit: false,
      actStatus: true,
      statisticsList: [],
      whiteListVisible: false,
      flowLevel: null,
      firstFlag: false,
      isKit: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.curPath = to.path;
      vm.oldPath = from.path;
    });
  },
  created() {
    this.configInfo = {};
    this.isKit = this.$route.query?.isKit;
    console.log(111, this.isKit);
    // qcTaskId异常告警
    if (!this.$route.query?.qcTaskId) {
      Sentry.captureMessage(
        `[seleteById] params: ${JSON.stringify({
          qcTaskId: this.$route.query.qcTaskId,
        })}, user: ${JSON.stringify(this.userInfo)}`,
      );
    }
    if (this.$route.query.qcTaskId) {
      seleteById({
        qcTaskId: this.$route.query.qcTaskId,
        isKit: this.$route.query.isKit,
      }).then((res) => {
        this.flowInfo = res.data?.data;
        this.flowInfo.order = res.data?.data?.orderId;
        this.checkNotice();
        if (
          this.flowInfo.qcId == this.userInfo.staffId ||
          this.roles.includes(1)
        ) {
          this.activeName = '' + this.flowInfo.status;
        }
        if (
          parseInt(this.$route.query.taskType) === 1 &&
          parseInt(this.$route.query.checkDistribute) === 1 &&
          parseInt(this.$route.query.canDistribute) === 1
        ) {
          if (this.activeName === '2') {
            checkQcSingleOrMulti({ qcTaskId: this.$route.query.qcTaskId }).then(
              (resl) => {
                this.dialogVisible = resl.data.data < 0;
              },
            );
          }
        }
        if (this.activeName === '1') {
          this.$nextTick(() => {
            this.$refs.ori?.init();
          });
        } else if (this.activeName === '2') {
          this.$nextTick(() => {
            this.$refs.process?.init();
          });
        } else if (this.activeName === '3') {
          this.$nextTick(() => {
            this.$refs.qcDown?.init();
          });
        } else if (this.activeName === '4') {
          this.$nextTick(() => {
            this.$refs.zkStatistics?.init();
          });
        } else if (this.activeName === '5') {
          this.$nextTick(() => {
            this.$refs.qcProjectNotice?.getNotice();
          });
        }
      });
    }
    this.staParams = {
      u_id: this.userInfo.staffId,
      time: new Date().getTime(),
      browser: navigator.userAgent.toLowerCase(),
      url: document.URL,
      scene_name: '质控任务详情',
    };
  },
  computed: {
    ...mapGetters(['permissions']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      roles: (state) => state.user.roles,
    }),
  },

  mounted() {
    this.statistics();
  },

  methods: {
    checkNotice() {
      if (!this.flowInfo.detailOperateTime && this.flowInfo.status == 2) {
        this.firstFlag = true;
        if (this.$route.query.isKit == 'true') {
          this.isShowKit = true;
        } else {
          if (parseInt(this.$route.query.taskType) === 1) {
            if (this.flowInfo.qcOrderType == 1) {
              this.isShowMainQc = true;
            } else {
              this.isShowMainMTQC = true;
            }
          } else {
            if (this.flowInfo.qcOrderType == 1) {
              this.isShowChildQc = true;
            } else {
              this.isShowChildMTQC = true;
            }
          }
        }
      }
    },
    closeNotice() {
      this.isShowMainQc = false;
      this.isShowMainMTQC = false;
      this.isShowChildQc = false;
      this.isShowChildMTQC = false;
      this.isShowKit = false;
      this.firstFlag = false;
    },
    // 接收子组件传过来的flowLevel
    getFlowLevel(val) {
      this.flowLevel = val;
    },

    // 预览并领取
    previewNotice() {
      this.$message.warning('请先预览稿件');
    },

    // 获取预览原稿子组件传过来的值
    getPreviewStatus(val) {
      this.isShowPreBtn = val;
    },

    // 获取未处理句数
    getSentCount() {
      incompleteSentCount({
        orderId: this.flowInfo.orderId,
        qcTaskId: this.flowInfo.id,
        qcTaskType: this.flowInfo.taskType,
      }).then((res) => {
        this.untreatedSentCount = res.data.data;
      });
    },

    statistics() {
      statistics(
        Object.assign(
          {
            event_type: 'view',
            ref_url: this.oldPath,
          },
          this.staParams,
        ),
      );
    },

    // 打开黑名单管理弹窗
    showBlackList() {
      this.actStatus = false;
      this.blackListVisible = true;
      this.$nextTick(() => {
        this.$refs.blackListOption.init();
      });
      this.staParams = {
        u_id: this.userInfo.staffId,
        time: new Date().getTime(),
        browser: navigator.userAgent.toLowerCase(),
        url: document.URL,
        scene_name: '质控任务详情',
      };
    },

    // 打开白名单管理弹窗
    showWhiteList() {
      this.actStatus = false;
      this.whiteListVisible = true;
      this.$nextTick(() => {
        this.$refs.whiteListOption.init();
      });
      this.staParams = {
        u_id: this.userInfo.staffId,
        time: new Date().getTime(),
        browser: navigator.userAgent.toLowerCase(),
        url: document.URL,
        scene_name: '质控任务详情',
      };
    },

    submitSubQcTask(item, index) {
      let orderId = this.flowInfo.orderId;
      checkSubmitSubTask({
        qcTaskId: item.qcTaskId,
        qcId: this.userInfo.staffId,
        operateType: 1,
      }).then((res) => {
        this.$confirm(
          '此操作将结束子质控任务' + (index + 1) + ', 是否继续?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showCancelButton: true,
            type: 'warning',
          },
        )
          .then(() => {
            submitSubQcTask({
              qcTaskId: item.qcTaskId,
              qcId: this.userInfo.staffId,
              operateType: 2,
              submitType: 1,
            }).then((res) => {
              this.$message.success('提交子质控任务成功！');
              subTaskList({ orderId: orderId }).then((res) => {
                this.qcListData = res.data.data;
                if (this.qcListData.length === 0) {
                  this.dialogQcListVisible = false;
                }
              });
            });
          })
          .catch(() => {});
      });
    },

    cancelQcTask(item, index) {
      let orderId = this.flowInfo.orderId;
      this.$confirm(
        '此操作将取消子质控任务' + (index + 1) + ', 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showCancelButton: true,
          type: 'warning',
        },
      )
        .then(() => {
          cancelQcTask({
            qcTaskId: item.qcTaskId,
            qcId: this.userInfo.staffId,
          }).then((res) => {
            let code = res.data.data;
            if (code === -2) {
              this.$message.error('该质控任务状态已修改');
            } else if (code === -3) {
              this.$message.error('没有权限提交');
            } else if (code > 0) {
              this.$message.success('取消子质控任务成功！');
              subTaskList({ orderId: orderId }).then((res) => {
                this.qcListData = res.data.data;
                if (this.qcListData.length === 0) {
                  this.dialogQcListVisible = false;
                }
              });
            } else if (code === -99) {
              this.$message.error('系统异常');
            }
          });
        })
        .catch(() => {});
    },

    // 主质控可以整体提交任务的条件是
    overallDubmission() {
      this.dialogQcListVisible = false;
    },

    // 从qc-detail传递mainTaskStatus
    changeMainTaskStatus(val) {
      this.mainTaskStatus = val;
    },

    formatDate(time) {
      let date = new Date(parseFloat(time));
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    },

    handleClick(tab, event) {
      this.activeName = tab.name;
      if (this.activeName === '1') {
        this.$refs.ori.init();
      } else if (this.activeName === '2') {
        this.$refs.process.init();
      } else if (this.activeName === '3') {
        this.$refs.qcDown.init();
      } else if (this.activeName === '4') {
        this.$refs.zkStatistics.init();
      } else if (this.activeName === '5') {
        this.$refs.qcProjectNotice.getNotice();
      }
    },

    btnReturnSuccess(msg = '提交成功', path = '/refresh', fn) {
      this.$message.success({
        message: msg,
        duration: 1500,
        onClose: () => {
          if (fn) {
            fn();
          }
          this.$router.replace({
            path: path,
          });
        },
      });
    },

    btnReceviewSuccess(msg = '领取成功', path = '/refresh', fn) {
      this.$message.success({
        message: msg,
        duration: 1500,
        onClose: () => {
          if (fn) {
            fn();
          }
          this.$router.replace({
            path: path,
          });
        },
      });
    },

    btnReturnFail(msg, path, fn) {
      this.$message.error({
        message: msg || '提交失败',
        duration: 1500,
        onClose: () => {
          if (fn) {
            fn();
          }
          this.$router.replace({
            path: path || '/refresh',
          });
        },
      });
    },

    receiveQctask() {
      this.actStatus = false;
      if (this.$route.query.isKit == 'true') {
        this.isShowKit = true;
      } else {
        if (parseInt(this.$route.query.taskType) === 1) {
          if (this.flowInfo.qcOrderType == 1) {
            this.isShowMainQc = true;
          } else {
            this.isShowMainMTQC = true;
          }
        } else {
          if (this.flowInfo.qcOrderType == 1) {
            this.isShowChildQc = true;
          } else {
            this.isShowChildMTQC = true;
          }
        }
      }
    },

    // 领取质控任务
    reciveQc() {
      receiveQc({
        qcTaskId: this.$route.query.qcTaskId,
        qcId: this.userInfo.staffId,
        orderId: this.flowInfo.orderId,
        isKit: this.$route.query.isKit,
      }).then((res) => {
        this.btnReceviewSuccess();
        this.isShowMainQc = false;
        this.isShowChildQc = false;
        this.isShowMainMTQC = false;
        this.isShowChildMTQC = false;
        if (this.$route.query.isKit == 'true') {
          this.$closePage();
          this.$router.push({
            path: '/qc/flow/qc-check/' + this.flowInfo.orderId,
          });
        }
      });
      statistics(
        Object.assign(
          {
            event_name: '领取任务',
            event_type: 'click',
            class_name: 'receiveQc',
            class_url: '/dotadmin/dotadmin/qcflow/receiveQc',
            event_params:
              '{qcTaskId: this.$route.query.qcTaskId, qcId: this.userInfo.staffId, orderId: this.flowInfo.orderId}',
          },
          this.staParams,
        ),
      );
    },

    // 提交质控任务
    submitQctask(taskType) {
      this.getSentCount();
      if (taskType === 1) {
        // 主质控提交
        getUndealtWordNum({
          orderId: this.flowInfo.orderId,
        }).then((res) => {
          const surplusWord = res.data?.data?.wordCountUndealed;
          if (surplusWord > 0) {
            this.$alert(
              '当前订单仍存在未完成分配的质控任务，请联系PM进行剩余质控任务配置！',
              '质控任务整体提交失败',
              {
                confirmButtonText: '确定',
              },
            );
          } else {
            checkSubmitMainTask({ qcTaskId: this.$route.query.qcTaskId }).then(
              (res) => {
                let num = res.data?.data;
                if (num === -1) {
                  this.$message.error('任务状态已修改');
                  this.reflash();
                } else if (num === -5) {
                  this.$message.error('不是主任务');
                } else if (num === -2) {
                  this.$message.error('流程已提交');
                  this.reflash();
                } else if (num === -3 || num === -4 || num === -6) {
                  this.checkSubmitMainTaskCode = num;
                  this.dialogQcListVisible = true;
                  subTaskList({ orderId: this.flowInfo.orderId }).then(
                    (res) => {
                      this.qcListData = res.data?.data;
                    },
                  );
                } else if (num === 1 || num === 2 || num === 0) {
                  incompleteSentCount({
                    orderId: this.flowInfo.orderId,
                    qcTaskId: this.flowInfo.id,
                    qcTaskType: this.flowInfo.taskType,
                  }).then((res) => {
                    this.untreatedSentCount = res.data?.data;
                    this.$alert(
                      `温馨提示：你即将提交质控任务，确认是否已经质控完毕，提交以后不能修改质控结果。<div class="m-t-10 c-333">剩余未处理句子数：<span class="c-red f-w-600">${this.untreatedSentCount}</span></div>`,
                      {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: '坚持提交',
                        cancelButtonText: '继续处理',
                        showCancelButton: true,
                        callback: (action) => {
                          if (action === 'confirm') {
                            submitMainQcTask({
                              qcTaskId: this.$route.query.qcTaskId,
                              qcId: this.userInfo.staffId,
                            }).then((res) => {
                              // code = 101时，在axios页面已经完成了跳转，这里不需要再跳
                              if (res.data?.code === 101) {
                                this.$closePage();
                                return;
                              }
                              this.btnReturnSuccess();
                            });
                          } else {
                            this.reflash();
                          }
                        },
                      },
                    );
                  });
                }
              },
            );
            statistics(
              Object.assign(
                {
                  event_name: '质控任务整体提交',
                  event_type: 'click',
                  class_name: 'checkSubmitMainTask',
                  class_url: '/dotadmin/dotadmin/qc/checkSubmitMainTask',
                  event_params: '{qcTaskId: this.$route.query.qcTaskId}',
                },
                this.staParams,
              ),
            );
          }
        });
      } else {
        // 子质控提交
        checkSubmitSubTask({
          qcTaskId: this.$route.query.qcTaskId,
          qcId: this.userInfo.staffId,
          operateType: 2,
        }).then((res) => {
          if (res.data?.code !== 101) {
            getSpeedAndEditRemind({
              qcTaskId: this.$route.query.qcTaskId,
              remindType: 2, //type--1.过程预警 2.提交预警
            }).then((res) => {
              let msg = '';
              if (res.data.data) {
                msg =
                  res.data.data === 1
                    ? 'transkit小秘书提醒您：检测当前提交速度过快，确认提交吗？'
                    : 'transkit小秘书提醒您：检测当前修改率过低，请详细审核后提交哦～';
              }
              this.$alert(
                `温馨提示：请确认是否提交子质控任务，提交以后不可修改。<div class="c-red">${msg}</div><div class="m-t-10 c-333">剩余未处理句子数：<span class="c-red f-w-600">${this.untreatedSentCount}</span></div>`,
                {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: '坚持提交',
                  cancelButtonText: '继续处理',
                  showCancelButton: true,
                  callback: (action) => {
                    if (action === 'confirm') {
                      this.isLoad = true;
                      submitSubQcTask({
                        qcTaskId: this.$route.query.qcTaskId,
                        qcId: this.userInfo.staffId,
                        submitType: 2,
                      }).then((res) => {
                        this.btnReturnSuccess();
                      });
                    } else {
                      this.reflash();
                    }
                  },
                },
              );
            });
          } else {
            this.$closePage();
            return;
          }
        });
        statistics(
          Object.assign(
            {
              event_name: '子质控任务提交',
              event_type: 'click',
              class_name: 'checkSubmitSubTask',
              class_url: '/dotadmin/dotadmin/qc/checkSubmitSubTask',
              event_params:
                '{qcTaskId: this.$route.query.qcTaskId, qcId: this.userInfo.staffId,operateType:2}',
            },
            this.staParams,
          ),
        );
      }
    },

    reflash() {
      this.$router.replace({
        path: '/refresh',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.avue-view {
  background: #ffffff;
  padding: 20px;
  min-height: calc(100vh - 100px);
}
.desc-info {
  width: 100%;
  padding-left: 0;
  > span {
    display: inline-block;
    margin-right: 50px;
    > em {
      color: #e6a23c;
      font-weight: bold;
    }
  }
}
.dialog-div {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.slef-footer {
  display: flex;
  justify-content: space-around;
}
:deep(.el-card__body) {
  padding: 0 !important;
}
.taskTag {
  right: -5px;
  top: -17px;
}
</style>
